<script>
  import { fade } from 'svelte/transition'
  import { quintOut } from 'svelte/easing'
  import { createEventDispatcher } from 'svelte'
  import FilterElement from './FilterElement.svelte'

  export let showFilters = false
  export let filters = {}
  export let origin = []
  const dispatch = createEventDispatcher()
  let filtersView = getFiltersView(filters)

  function getFiltersView (filters) {
    let view = []
    Object.keys(filters).forEach(fk => {
      const filter = filters[fk]
      if (filter.group) {
        const i = view.findIndex(p => p.title === filter.group)
        if (i > -1) {
          view[i].keys.push(fk)
        } else {
          view.push({group: true, title: filter.group, keys: [fk]})
        }
        return
      }
      view.push(fk)
    })
    // console.log('[DEBUG] filters view:', view)
    return view
  }

</script>

<div class="pl-8 pr-10 py-10 bg-white text-left filters-panel shadow-xl absolute h-full overflow-y-auto scroll"
     style={(showFilters ? 'width: 280px;' : 'width: 0;') + ' scrollbar-width: none;'}
     in:fade={{ delay: 400, duration:400, easing: quintOut}}
>
  <div class="text-black mb-4">FILTERS</div>
  <div class="text-black text-right text-base text-gray-400 mb-4 cursor-pointer"
       on:click={() => { dispatch('clear') }}
  >clear all
  </div>

  <div class="absolute uppercase flex items-center btn" style="top: 2rem; right: 2.2rem"
       on:click={() => { dispatch('close') }}
  >
    <i class="material-icons icon ml-2 close-icon">close</i>
  </div>

  {#each filtersView as elem}
    {#if elem.group}
      <div class="border-l-2 border-red-200 pl-3 -ml-3">
        <div class="font-medium text-gray-700 pb-1" style="padding-left: 0.1rem">{elem.title}</div>
        <div class="">
          {#each elem.keys as fk}
            <FilterElement bind:filter={filters[fk]} {fk} {filters} {origin} />
          {/each}
        </div>
      </div>
    {:else}
      <FilterElement bind:filter={filters[elem]} fk={elem} {filters} {origin} />
    {/if}
  {/each}

  <div class="py-1">&nbsp</div>
</div>

<style>
    .btn:hover {
        cursor: pointer;
    }

    .close-icon {
        color: #a0a0a0;
        font-size: 2.0rem;
    }

    .close-icon:hover {
        color: #1d1d1d;
    }
</style>